import { render } from "./home-en.vue?vue&type=template&id=50bfd406&scoped=true&ts=true"
import script from "./home-en.vue?vue&type=script&lang=ts"
export * from "./home-en.vue?vue&type=script&lang=ts"

import "./home-en.vue?vue&type=style&index=0&id=50bfd406&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50bfd406"]])

export default __exports__